<div class="points-summary-bar d-flex justify-content-between align-items-center mt-2 d-lg-none">
  <!-- Back Button -->
  <ng-container *notInProductCode="productcode.SingleGameBuyer">
    <div class="back-btn text-white cursor-pointer d-lg-none gloss-black" [routerLink]="[backButtonLink]">
      <span class="material-icons"> arrow_back_ios </span>
    </div>
  </ng-container>
  <ng-container *inProductCode="productcode.SingleGameBuyer">
    <div class="back-btn text-white cursor-pointer d-lg-none gloss-black" [routerLink]="['/rewards']">
      <span class="material-icons"> arrow_back_ios </span>
    </div>
  </ng-container>
  <!-- Points Bar -->
  <div class="justify-content-center h-100">
    <fgb-points-summary></fgb-points-summary>
  </div>
</div>
